import { useProcessAnalysisStore } from '../../store/process-analysis-store/process-analysis-store';
import { Filters as FiltersAgents } from './agents-tab/filters/filters';
import { Filters as FiltersBoards } from './boards-tab/filters/filters';
import { Filters as FiltersPortfolios } from './portfolios-tab/filters/filters';
import { Tab } from './process-analysis.type';
import { Filters as FiltersTeams } from './teams-tab/filters/filters';

export const ProcessAnalysisFilters = () => {
  const activeTab = useProcessAnalysisStore((state) => state.activeTab);

  switch (activeTab) {
    case Tab.Portfolios:
      return <FiltersPortfolios />;
    case Tab.Teams:
      return <FiltersTeams />;
    case Tab.Boards:
      return <FiltersBoards />;
    case Tab.Agents:
      return <FiltersAgents />;
    default:
      return null;
  }
};
